<template>
  <div class="loan-settings">
    <b-row align-h="between" class="mb-3">
      <b-col cols="8">
        <h3 class="mb-0">Credit Loan Type Settings</h3>
      </b-col>
      <!-- <b-col cols="4" class="d-flex align-items-center justify-content-end">
        Autosave
        <el-switch v-model="enable_autosave" active-color="#099A78" class="ml-2"></el-switch>
        <b-form-input v-model="autosave_time" type="text" @keydown="preventNonNumericInput" style="width: 150px;"
          class="ml-3 mr-2" :disabled="enable_autosave === false"></b-form-input>
        <span>sec</span>
      </b-col> -->
    </b-row>
    <b-card no-body class="p-3" >
      <b-row>
        <b-col cols="12">
          <div class="table-listings">
						<el-table ref="ccrisTable" style="width: 100%" :loading="is_loading"
							:data="tableData" default-expand-all :show-header="false" row-class-name="bg-dark">
							<el-table-column type="expand">
								<template slot-scope="scope">
									
									<b-row>
										<b-col cols="3">
											<b-form-group label="Stemp Duty">
												<b-input-group size="sm"  append="%">
													<b-form-input
															v-model="scope.row.stamp_duty_rate"
															type="number"
															maxlength="5"
															step="0.01"
													>
													</b-form-input>
												</b-input-group>
                    	</b-form-group>
										</b-col>
										<b-col cols="3">
											<b-form-group label="Vetting and Facilitation Services Fees">
												<b-input-group size="sm"  append="%">
													<b-form-input
															v-model="scope.row.vet_fac_rate"
															type="number"
															maxlength="5"
															step="0.01"
													>
													</b-form-input>
												</b-input-group>
                    	</b-form-group>
										</b-col>
										<b-col cols="3">
											<b-form-group label="Legal Fees">
												<b-input-group size="sm"  prepend="RM">
													<b-form-input
															v-model="scope.row.legal_fees"
															type="number"
															step="0.01"
													>
													</b-form-input>
												</b-input-group>
                    	</b-form-group>
										</b-col>
										<b-col cols="3">
											<b-form-group label="SST Rate">
												<b-input-group size="sm"  append="%">
													<b-form-input
															v-model="scope.row.sst_rate"
															type="number"
															maxlength="5"
															step="0.01"
													>
													</b-form-input>
												</b-input-group>
                    	</b-form-group>
										</b-col>
										<b-col cols="12">
											<b-form-group label="Stakeholder Sum - Installment Months">
												<b-row>
													<b-col cols="3" v-for="(itm,index) in scope.row.stakeholder_range" :key="index">
														<b-input-group size="sm"  :prepend="(index + 1) + ' Years =' " append="Months">
															<b-form-input
																	v-model="scope.row.stakeholder_range[index].months"
																	type="number"
																	maxlength="2"
																	step="1"
															>
														</b-form-input>
													</b-input-group>
													</b-col>
												</b-row>

                    	</b-form-group>
										</b-col>
									</b-row>
									<div class="text-right p-2">
										<el-button type="warning" class="mx-1" size="mini" @click="update(scope.row)" icon="el-icon-circle-check">Update</el-button>
									</div>
								</template>
							</el-table-column>
							<el-table-column label="Credit Loan Type">
								<template slot-scope="scope">
									<h3 class="mb-0 text-light">{{ scope.row.name }}</h3>
								</template>
							</el-table-column>
						</el-table>
					</div>
        </b-col>
      </b-row>
      
    </b-card>

  </div>
</template>
<script>
import {cloneDeep, isEqual} from 'lodash'
import { Table, TableColumn, Button } from 'element-ui'
import { mapActions } from 'pinia'
import { useCommonStore } from '@/stores/commonStore'
import { preventNonNumericInput } from '@/assets/js/formValidations.js'

export default {
  components: {
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
			is_loading: false,
			oldTableData: [],
      tableData:[]
    }
  },
  created() {
   this.getListing()
  },
  methods: {
    ...mapActions(useCommonStore, ['getLoanTypes','updateLoanType']),
    preventNonNumericInput,
    getListing() {
			this.is_loading = true;
      this.getLoanTypes(true).then(resp => {
				let tData = [];
				for (let i = 0; i < resp.length; i++) {
					let itm = resp[i];
					itm.stakeholder_range = this.getDefaultRanges(_gHlp.getValue(itm,'stakeholder_range',[]))
					tData.push(itm)
				}

				this.tableData = tData
				this.oldTableData = cloneDeep(tData)
				this.is_loading = false;
			}).catch(err => {
				this.is_loading = false;
			})
    },
		getDefaultRanges(itmRange){
			let range = [];
			for (let x = 0; x < 7; x++) {
				let y = x + 1;
				let alt = (y < 3) ? 1 : ((y < 5) ? 2 : (y < 7) ? 3 : 4);
				range.push({
					years: parseInt(_gHlp.getValue(itmRange,x+'.years',y)),
					months: parseInt(_gHlp.getValue(itmRange,x+'.months',alt))
				})	
			}		
			return range;
		},
		getParams(item) {
			if(_gHlp.isEmpty(item)) return {}
			return {
				stamp_duty_rate : parseFloat(item.stamp_duty_rate),
				vet_fac_rate : parseFloat(item.vet_fac_rate),
				sst_rate : parseFloat(item.sst_rate),
				stakeholder_range : this.getDefaultRanges(_gHlp.getValue(item,'stakeholder_range',[])),
				legal_fees : parseFloat(item.legal_fees),
			}
		},
    update(item) {
			const newData = this.getParams(item)	
			const oldData = this.getParams(this.oldTableData.find(itm => itm.id === item.id));
			if(_gHlp.isEmpty(oldData) || !isEqual(newData, oldData)) {
				this.updateLoanType(item.id,newData).then(resp => {
					this.getListing();
					_gNotif.notifySuccess("Credit loan type has been update",10000,'success')
				});	
			}
    }
  }
}
</script>